<template>
  <fragment>
    <div class="energy-wrap" :style="{'background-image':'url('+ swiperOption.numBgc +')'}">
      <span :style="styleOption('bg').fontStyle">{{swiperOption.leftInput}}</span>
      <span :style="styleOption('bg').countStyle">{{remainingEnergy}}</span>
      <span :style="styleOption('bg').fontStyle">{{swiperOption.rightInput}}</span>
    </div>
    <div class="swiper-wrap swiper-no-swiping" :style="{'background-image':'url('+ swiperOption.swiperBgc +')'}">
      <swiper :auto-update="true" :auto-destroy="true" :delete-instance-on-destroy="true"
        :cleanup-styles-on-destroy="true" ref="mySwiper" v-if="prizeInfoList.length>0" :options="swiperOptions">
        <swiper-slide :key="index" v-for="(item,index) in prizeInfoList">
          <p :style="styleOption('swiper').fontStyle">恭喜{{item.userPhone}}抽到{{item.prizeName | formatStr}}</p>
        </swiper-slide>
      </swiper>
    </div>
    <div class="grid-wrap">
      <img style="width:100%;" :src="gridBgImg" alt="">
      <ul>
        <li :key="index" :class="[currentIndex==index?'current':'']" v-for="(item,index) in prizeList"
          :style="item.style">
          <img v-show="currentIndex==index" :src="item.columnBrightImage" alt />
          <img v-show="currentIndex!=index" :src="item.columnImage" alt />
        </li>
      </ul>
    </div>
    <div class="grid-btn-wrap" :style="{'background-image':'url('+ gridBtnImgSrc +')'}">
      <button class="btn" :disabled="btnDisabled" @click="startLottery"></button>
    </div>
    <div class="rule-wrap" v-if="showRules">
      <div class="header">
        <img :src="ruleOption.ruleHeaderImg" alt />
      </div>
      <div class="content">
        <div class="hot-area">
          <div v-for="(item,index) in 3" @click="changeRule(index)" :class="current==index?'current':''"
            :current="current" :key="item"></div>
        </div>
        <img :src="ruleOption.ruleLeftImg" v-show="current==0" alt />
        <img :src="ruleOption.ruleMiddleImg" v-show="current==1" alt />
        <img :src="ruleOption.ruleRightImg" v-show="current==2" alt />
      </div>
      <div class="footer" @click="handleClick('rule')">
        <img :src="ruleOption.ruleBottomImg" alt />
      </div>
    </div>
    <div class="reward-wrap" v-if="this.activityStatus>2">
      <div class="header">
        <img :src="awardOption.awardHeaderImg" alt />
      </div>
      <div :class="recordList.length <=0 ? 'content' : 'content active'" ref="content" @scroll="handleRecordScroll">
        <template v-if="recordList.length<=0">
          <img :src="awardOption.awardMiddleImg" alt />
        </template>
        <template v-else>
          <img :src="item.prizeImage" @click="checkPrize(item)" alt :key="index" v-for="(item,index) in recordList" />
        </template>
      </div>
      <div class="footer">
        <img :src="awardOption.ruleBottomImg" alt />
      </div>
    </div>
    <Cmask :showMask="showMask">
      <div class="content-wrap">
        <!-- 第一次进入且有引导图 显示引导图 -->
        <div class="guide-wrap" v-if="beFirst&&modalType=='guide'" @click="closeDialog">
          <img :src="base.guideUrl" alt />
        </div>
        <!-- 数值不足时候显示图片 -->
        <div class="countError-wrap" v-else-if="modalType=='countError'">
          <img :src="gridOption.countEnable" alt />
        </div>
        <!-- 奖品弹窗 //Integer	奖品类型	1怪兽充点券 2外部兑换码 3实物奖品 4 无兑换码礼包 -->
        <div class="prize-wrap" :style="{'background-image':'url('+ modelBgc +')'}" v-else-if="modalType=='prize'"
          @click="handleCopy">
          <fragment v-if="prize.prizeType==0"></fragment>
          <fragment v-else-if="prize.prizeType==1"></fragment>
          <!-- 点击复制第三方券码 -->
          <span v-else-if="prize.prizeType==2" class="ticket-code" :style="prizeFontStyle">{{ticketCode}}</span>
          <div v-else-if="prize.prizeType==3">
            <div class="form">
              <fragment :key="index" v-for="(item,index) in prizeFormItems">
                <div v-if="item.paramName=='name'" class="form-row">
                  <label :style="prizeFontStyle" for class="form-label">姓名：</label>
                  <input :style="prizeBorderStyle" :disabled="userInfoBtnStatus===1" maxlength="15" class="form-input"
                    type="text" :placeholder="item.tips" v-model="userInfo.name" />
                  <!-- :placeholder="item.tips" -->
                </div>
                <div v-else-if="item.paramName=='phone'" class="form-row">
                  <label :style="prizeFontStyle" for class="form-label">手机号：</label>
                  <input :style="prizeBorderStyle" :disabled="userInfoBtnStatus===1" maxlength="11" class="form-input"
                    type="tel" :placeholder="item.tips" v-model="userInfo.phone" />
                </div>
                <div v-else-if="item.paramName=='address'" class="form-row">
                  <label :style="prizeFontStyle" for class="form-label">收货地址：</label>
                  <textarea :style="prizeBorderStyle" :disabled="userInfoBtnStatus===1" maxlength="500"
                    class="form-textarea" rows="3" :placeholder="item.tips" v-model="userInfo.address"
                    contenteditable="true"></textarea>
                </div>
                <div v-else-if="item.paramName=='remark'" class="form-row">
                  <label :style="prizeFontStyle" for class="form-label">备注：</label>
                  <input :style="prizeBorderStyle" :disabled="userInfoBtnStatus===1" maxlength="500" class="form-input"
                    type="text" :placeholder="item.tips" v-model="userInfo.remark" />
                </div>
                <div v-else-if="item.paramName=='other'" class="form-row">
                  <label :style="prizeFontStyle" for class="form-label">其他：</label>
                  <textarea :style="prizeBorderStyle" :disabled="userInfoBtnStatus===1" maxlength="500"
                    class="form-textarea" rows="3" :placeholder="item.tips" v-model="userInfo.other"
                    contenteditable="true"></textarea>
                </div>
              </fragment>
            </div>
            <img :src="submitBtn" @click="addLotteryAddress" v-if="userInfoBtnStatus===0" class="btn" />
            <img :src="submittedBtn" v-if="userInfoBtnStatus===1" class="btn" />
          </div>
          <!-- TODO：点击复制提示文字 tipMessage -->
          <div class="prize-area" @click="handleClick('prize')" v-else-if="prize.prizeType==4"></div>
          <div class="prize-close" v-if="prize.prizeType==0" @click="closeDialog"></div>
        </div>
        <div class="line" v-if="modalType!=='guide'">
          <span v-for="item in 5" :key="item"></span>
          <img class="guanbi" src="./../../../assets/imgs/close.png" @click="closeDialog" alt />
          <!-- 用于增加增加次数奖品关闭 -->
          <div v-if="[0, 7].includes(prize.prizeType)" class="guanbi2" @click="closeDialog"></div>
        </div>
      </div>
    </Cmask>
    <Cmask v-show="eleLoading">
      <div class="eleLoadingContent">
        <img class="eleLoading" src="https://static.enmonster.com/1385169439842111488">
      </div>
    </Cmask>
  </fragment>
</template>

<script>
import { isMiniApplets, isMiNiProgram } from "@/utils/browser";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
var rem = require('@/utils/rem')

export default {
  name: "DiyGrid",
  props: {
    info: {
      type: Object,
      required: true
    },
    activityId: {
      type: String,
      required: true
    },
    openId: {
      type: String,
      required: true
    },
    activityStatus: {
      //活动状态 (0,"未发布"),(1,"已发布"),(2,"未开始"),(3,"进行中"),(4,"已结束"),
      type: Number,
      required: true
    },
    activityType: {
      type: Number,
      required: true
    },
    base: {
      type: Object,
      required: true
    },
    showRules: {
      type: Boolean,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    styleOption() {
      //活动数值或中奖轮播的样式设置
      return str => {
        let fontStyle = {};
        let countStyle = {};
        let swiperOption = this.info.props.imgList.swiperOption;
        if (str == "swiper") {
          fontStyle = {
            "font-size": `${swiperOption.awardFontfontSize / 2}px`,
            color: swiperOption.awardFontColor,
            "font-style": swiperOption.awardFontFontStyle.includes("italic")
              ? "italic"
              : "",
            "font-weight": swiperOption.awardFontFontStyle.includes("bold")
              ? "bold"
              : "",
            "text-stroke": `1px ${swiperOption.awardFontBoxShadow}`
          };
        } else {
          fontStyle = {
            "font-size": `${swiperOption.fontfontSize / 2}px`,
            color: swiperOption.fontColor,
            "font-style": swiperOption.fontFontStyle.includes("italic")
              ? "italic"
              : "",
            "font-weight": swiperOption.fontFontStyle.includes("bold")
              ? "bold"
              : "",
            "text-stroke": `1px ${swiperOption.fontBoxShadow}`
          };
          countStyle = {
            "font-size": `${swiperOption.countfontSize / 2}px`,
            color: swiperOption.countColor,
            "font-style": swiperOption.countFontStyle.includes("italic")
              ? "italic"
              : "",
            "font-weight": swiperOption.countFontStyle.includes("bold")
              ? "bold"
              : "",
            "text-stroke": `1px ${swiperOption.countBoxShadow}`
          };
        }
        return { fontStyle, countStyle };
      };
    },
    gridBtnImgSrc() {
      // 抽奖按钮背景
      let bgSrc = "";
      let { lotteryingBtn, unlotteryBtn } = this.info.props.imgList.gridOption;
      if (this.isLottery) {
        bgSrc = lotteryingBtn;
      } else {
        bgSrc = unlotteryBtn;
      }
      return bgSrc;
    },
    gridBgImg() {
      // 抽奖九宫格背景
      let {
        isSpecStatus,
        lotterying,
        unlottery,
        speciOffbgc
      } = this.info.props.imgList.gridOption;
      let bgSrc = "";
      if (isSpecStatus) {
        if (this.isLottery) {
          bgSrc = lotterying;
        } else {
          bgSrc = unlottery;
        }
      } else {
        bgSrc = speciOffbgc;
      }
      return bgSrc;
    },
    enterSource() {
      return this.getEnterSource();
    },
  },
  inject: ['getEnterSource'],
  created() { },
  data() {
    return {
      prizeIndex: '',
      remainingEnergy: 0, //能量
      remainingOpportunities: "", //抽奖次数
      prizeList: [],
      prizeInfoList: [],
      isLottery: false, //是否在抽奖
      // 我的奖品配置
      awardOption: {},
      // 九宫格配置
      gridOption: {},
      // 轮播配置
      swiperOption: {},
      // // 规则配置
      ruleOption: {},
      beFirst: false, //是否是第一次打开
      recordList: [], //中奖记录
      prize: {
        prizeType: 3
      }, //奖品信息
      // form动态配置
      prizeFormItems: [],
      activityGuide: "", //活动引导图
      btnDisabled: false,
      currentIndex: -1, //起点位置
      timer: 0, //每次转动定时器
      speed: 200, //初始转动速度
      times: 0, // 转动次数
      cycle: 8, //转动基数：至少需要转动多少次再进入抽奖环节
      prizeColumn: 5, //中奖位置
      showMask: false, //弹框是否开启
      userInfoBtnStatus: undefined,
      modalType: "", //弹出框的类型 //guide(引导图) countError(数值不足) prize(奖品)
      current: 0, //规则图片所在位置
      ticketCode: "", //第三方券码
      tipMessage: "", // 告知型奖品提示文字
      swiperOptions: {
        notNextTick: true,
        direction: "vertical", //控制滚动的方向
        autoplay: {
          disableOnInteraction: false,
          delay: 2000 //这里需要注意，如果想每2秒去自动切换，直接autoplay:2000是失效的，
        },
        loop: true,
        loopedSlides: 0,
        autoHeight: true,
        // height:39,
        disableOnInteraction: false
      },
      modelBgc: "",
      userInfo: {
        //填表型填写的用户信息
        phone: "",
        name: "",
        address: "",
        remark: "",
        other: ""
      },
      hasMore: true, // 是否有更多数据
      pageIndex: 1, // 分页页数
      pageSize: 5, // 分页条数
      submitBtn: "", // 未提交按钮
      submittedBtn: "", // 已提交按钮
      prizeFontStyle: {},
      prizeBorderStyle: {},
      clickForwardConfig: {}, // 告知类奖品详情
      eleLoading: false
    };
  },
  watch: {
  },
  mounted() {
    this.formatData();
    this.getLotteryDetail();
    this.getRecordList();
    this.getLotteryUserList();
  },
  filters: {
    formatStr(str = []) {
      return str.length <= 4 ? str : str.substr(0, 4) + '...'
    }
  },
  methods: {
    //初始化数据
    formatData() {
      this.awardOption = this.info.props.imgList.awardOption;
      console.log(this.awardOption);
      this.gridOption = this.info.props.imgList.gridOption;
      this.ruleOption = this.info.props.imgList.ruleOption;
      this.swiperOption = this.info.props.imgList.swiperOption;
      this.modalType = "guide";
    },
    // 开始抽奖
    startLottery() {
      if (this.btnDisabled) {
        return;
      }
      this.eleLoading = true
      this.$log.senLog({
        pointID: '12010012',
        eventType: 2,
        businessData: {
          activityType: this.activityType !== undefined ? this.activityType : '',
          activityId: this.activityId || '',
          appSource: isMiniApplets() ? isMiniApplets() : '',
          enterSource: this.enterSource || '',
        }
      })
      this.btnDisabled = true; //设置按钮禁用
      this.handleLottery();
    },
    // 用户点击抽奖
    handleLottery() {
      let params = {
        activityId: this.activityId,
        openId: this.openId
      };
      this.$fetch(
        { url: "/ehs/activity/user/lottery", method: "post" },
        params
      ).then(res => {
        this.eleLoading = false
        if (res.success) {
          this.prizeColumn = res.model.prize.column; //获取奖品位置
          this.prize = res.model.prize; //获取奖品
          this.modalType = "prize";
          this.speed = 200; //设置初始速度
          this.isLottery = true; //设置是否在抽奖状态
          // this.remainingOpportunities = this.remainingOpportunities - 1; //点击之后就让次数减一
          this.currentIndex = -1; //设置抽奖开始位置
          this.prizeList.forEach((item, index) => {
            if (item.column == res.model.prize.column) {
              this.prizeIndex = index
            }
          })
          this.startRoll();
          // resolve();
        } else {
          this.btnDisabled = false; //设置按钮禁用
          if (res.errorCode == "CLA100118") {
            this.modalType = "countError";
            this.showMask = true;
            return;
          } else if (res.errorCode == "CLA100007") {
            // 活动未开始
            this.$toast({
              styles: {
                maskColor: "rgba(0,0,0,0)",
                background: "rgba(0,0,0,0.4)",
                messageColor: "#fff"
              },
              content: this.gridOption.actiUnstartTips,
              duration: 2000
            }).then(() => {
              console.log("finish");
            });
            return;
          } else if (res.errorCode == "CLA100117") {
            // 活动已经结束提示
            this.$toast({
              styles: {
                maskColor: "rgba(0,0,0,0)",
                background: "rgba(0,0,0,0.4)",
                messageColor: "#fff"
              },
              content: this.gridOption.actiFinishedTips,
              duration: 2000
            }).then(() => {
              console.log("finish");
            });
            return;
          }
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff"
            },
            content: res.errorMessage,
            duration: 2000
          }).then(() => {
            console.log("finish");
          });
        }
      });
    },
    // 开始转动
    startRoll() {
      this.times += 1; // 转动次数
      this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
      // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
      if (
        this.times > this.cycle + 10 &&
        (
          this.prizeIndex == this.currentIndex
          ||
          this.prizeIndex == -1
        )
      ) {
        clearTimeout(this.timer); // 清除转动定时器，停止转动
        this.times = 0;
        this.pageIndex = 1;
        this.recordList = [];
        setTimeout(() => {
          this.isLottery = false;
          this.btnDisabled = false;
          this.getLotteryDetail();
          this.getRecordList()
          // 0 告知类奖品   7 再抽N次
          if (this.prize.prizeType != 0 && this.prize.prizeType != 7) {
            this.getLotteryAddress();
          } else {
            this.showMask = true;
            this.modelBgc = this.prize.winPopupImage;
          }
        }, 500);
      } else {
        if (this.times < this.cycle) {
          this.speed -= 10; // 加快转动速度
        } else if (this.times === this.cycle) {
          // 随机获得一个中奖位置
          // const index = parseInt(Math.random() * 10, 0) || 0
          // this.prize = index
          // if (this.prize > 7) {
          //   this.prize = 7
          // }
          console.log(`中奖位置${JSON.stringify(this.prize)}`);
        } else if (
          this.times > this.cycle + 20 &&
          ((this.prizeColumn === 0 && this.currentIndex === 7) ||
            this.prizeColumn === this.currentIndex + 1)
        ) {
          this.speed += 110;
        } else {
          this.speed += 20;

        }
        if (this.speed < 40) {
          this.speed = 40;
        }
        if (this.speed > 300 && this.prizeColumn === -1) {
          // 处理没有配置兜底奖品，默认奖品弹窗
          clearTimeout(this.timer); // 清除转动定时器，停止转动
          this.times = 0;
          this.pageIndex = 1;
          this.recordList = [];
          if (this.prizeColumn === -1) {
            this.currentIndex = -1;
            this.showMask = true;
            this.modelBgc = this.prize.winPopupImage;
            setTimeout(() => {
              this.isLottery = false;
              this.btnDisabled = false;
              this.getLotteryDetail();
            }, 500);
          }
          return false
        }
        this.timer = setTimeout(this.startRoll, this.speed);
      }
    },

    // 每一次转动
    oneRoll() {
      let index = this.currentIndex; // 当前转动到哪个位置
      const count = this.prizeList.length; // 总共有多少个位置
      index += 1;
      if (index > count - 1) {
        index = 0;
      }
      this.currentIndex = index;
    },
    // 切换规则图片
    changeRule(index) {
      this.current = index;
      this.$log.senLog({
        pointID: '12010013',
        eventType: 2,
        businessData: {
          activityType: this.activityType !== undefined ? this.activityType : '',
          activityId: this.activityId || '',
          appSource: isMiniApplets() ? isMiniApplets() : '',
          enterSource: this.enterSource || '',
        }
      })
    },
    // 获取抽奖页面详情
    getLotteryDetail() {
      return new Promise(resolve => {
        let params = {
          activityId: this.activityId,
          openId: this.openId
        };
        this.$fetch(
          { url: "/ehs/activity/user/lottery/page/detail", method: "post" },
          params
        ).then(res => {
          if (res.success) {
            this.remainingEnergy = res.model.remainingEnergy; //能量
            // this.recordList = res.model.recordList || []; //中奖记录
            this.remainingOpportunities = res.model.remainingOpportunities; //抽奖次数
            this.beFirst = res.model.beFirst; //是否是第一次打开
            this.handlePrizeList(res.model.prizeList)
            // guideTitle: 是否开启引导弹窗
            if (this.beFirst && this.base.guideTitle) {
              this.showMask = true;
            }
            // resolve(res.model);
          } else {
            this.$toast({
              styles: {
                maskColor: "rgba(0,0,0,0)",
                background: "rgba(0,0,0,0.4)",
                messageColor: "#fff"
              },
              content: res.errorMessage,
              duration: 2000
            }).then(() => {
              console.log("finish");
            });
          }
        });
      });
    },
    // 处理格子位置
    handlePrizeList(list) {
      let awardList = this.info.awardList
      list.forEach(item => {
        for (let i = 0, len = awardList.length; i < len; i++) {
          
          if (item.column === awardList[i].columnNo) {
            console.log(awardList[i].positions[0].row)
            let style = `
              position:absolute;
              ${this.handleCss(`{height: ${awardList[i].moduleSize.h}px}`)};
              ${this.handleCss(`{width: ${awardList[i].moduleSize.w}px}`)};
              ${this.handleCss(`{${awardList[i].positions[0].row}: ${awardList[i].positions[0].value}px}`)};
              ${this.handleCss(`{${awardList[i].positions[1].column}: ${awardList[i].positions[1].value}px}`)};
              `
            item.style = style
          }
        }
      })
      this.prizeList = list
    },
    handleCss(options = {}) {
			let str = `.a${JSON.stringify(options).replace(/\"/g, '')}`
			let cssStyle = rem.prototype.generateRem(str).toString()
			cssStyle = cssStyle.substr(0, cssStyle.length - 1)
			cssStyle = cssStyle.slice(7)
			return cssStyle.replace(/\,/g, ';')
		},
    reset(px) {
			let fontSize = document.documentElement.style.fontSize.replace("px", "")
			let w = window.screen.width, scale = 1
			if (w >= 320 && w < 375) {
				scale = 1.2
			} else if (w <= 375) {
				scale = 1
			} else if (w > 375 && w <= 390) {
				scale = 0.97
			} else if (w > 390 && w <= 414) {
				scale = 0.91
			}
			return `${px / fontSize / scale}rem`;
		},
    // 分页获取奖品信息
    getRecordList() {
      let params = {
        openId: this.openId,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        activityId: this.activityId
      };
      this.$fetch(
        { url: "/ehs/activity/user/win/prize/page", method: "post" },
        params
      )
        .then(res => {
          if (res.success) {
            if (res.totalPage == this.pageIndex) {
              this.hasMore = false;
            } else {
              this.hasMore = true;
              this.pageIndex++;
            }
            this.recordList = [...this.recordList, ...res.model];
          } else {
            this.$toast({
              styles: {
                maskColor: "rgba(0,0,0,0)",
                background: "rgba(0,0,0,0.4)",
                messageColor: "#fff"
              },
              content: res.errorMessage,
              duration: 2000
            }).then(() => {
              console.log("finish");
            });
          }
        })
        .catch(_ => { });
    },
    // 奖品区域滚动加载更多
    handleRecordScroll() {
      let scrollTop = this.$refs["content"].scrollTop;
      let clientHeight = this.$refs["content"].clientHeight;
      let scrollHeight = this.$refs["content"].scrollHeight;
      if (scrollTop + clientHeight + 30 >= scrollHeight && this.hasMore) {
        this.hasMore = false;
        this.throttle(this.getRecordList, 2000)();
      }
    },
    // 节流器
    throttle(fn, interval = 500) {
      let timer = null;
      let firstTime = true;

      return function () {
        let args = arguments;
        if (firstTime) {
          // 第一次加载
          fn.apply(this, args);
          return (firstTime = false);
        }
        if (timer) {
          // 定时器正在执行中，跳过
          return;
        }
        timer = setTimeout(() => {
          // clearTimeout(timer);
          timer = null;
          fn.apply(this, args);
        }, interval);
      };
    },
    handleCopy() {
      if (2 == this.prize.prizeType) {
        this.copyMsg(this.ticketCode);
      }
    },
    // 复制文字
    copyMsg(msg) {
      this.$copyText(msg).then(
        e => {
          this.copySuccess();
        },
        err => {
          this.copyError();
        }
      );
    },
    // 复制成功的提示操作
    copySuccess() {
      this.$toast({
        styles: {
          maskColor: "rgba(0,0,0,0)",
          background: "rgba(0,0,0,0.4)",
          messageColor: "#fff"
        },
        content: "复制成功",
        duration: 2000
      }).then(() => {
        console.log("finish");
      });
    },
    // 复制失败的提示操作
    copyError() {
      this.$toast({
        styles: {
          maskColor: "rgba(0,0,0,0)",
          background: "rgba(0,0,0,0.4)",
          messageColor: "#fff"
        },
        content: "复制出错",
        duration: 2000
      }).then(() => {
        console.log("finish");
      });
    },
    // 收获地址信息查看
    getLotteryAddress() {
      let params = {
        activityId: this.activityId,
        openId: this.openId,
        recordId: this.prize.recordId
      };
      this.$fetch(
        { url: "/ehs/activity/user/address/getAddress", method: "post" },
        params
      ).then(res => {
        if (res.success) {
          let result = res.model;
          if (result.entityPrizeFormConfig) {
            this.prizeFormItems =
              result.entityPrizeFormConfig.prizeFormItems || [];
            this.submitBtn = result.entityPrizeFormConfig.submitBtn;
            this.submittedBtn = result.entityPrizeFormConfig.submittedBtn;
          }
          this.userInfoBtnStatus = result.status;
          this.modelBgc = result.winPopupImage;
          this.showMask = true;
          if (result.prizeType == 3) { // 表单类奖品
            let titleInputBoxCssConfig =
              result.entityPrizeFormConfig.titleInputBoxCssConfig;
            this.userInfo = {
              name: res.model.name,
              phone: res.model.phone,
              address: res.model.address,
              remark: res.model.remark,
              other: res.model.other
            };
            this.prizeFontStyle = {
              "font-size": `${titleInputBoxCssConfig.size / 2}px`,
              color: titleInputBoxCssConfig.color,
              "font-style": titleInputBoxCssConfig.style.includes("italic")
                ? "italic"
                : "",
              "font-weight": titleInputBoxCssConfig.style.includes("bold")
                ? "bold"
                : ""
              // "text-stroke": `1px ${titleInputBoxCssConfig.outline}`
            };
            this.prizeBorderStyle = {
              ...this.prizeFontStyle,
              "border-color": titleInputBoxCssConfig.color
            };
          } else if (result.prizeType == 2) { // 第三方券码
            this.ticketCode = result.prizeCode;
            let couponCssConfig = result.couponCssConfig;
            this.prizeFontStyle = {
              "font-size": `${couponCssConfig.size / 2}px`,
              color: couponCssConfig.color,
              "font-style": couponCssConfig.style.includes("italic")
                ? "italic"
                : "",
              "font-weight": couponCssConfig.style.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${couponCssConfig.outline}`
            };
          } else if (result.prizeType == 4) { // 告知类奖品
            if (result.clickForwardConfig.beCommonClickForward) { // 不区分平台统一配置
              this.clickForwardConfig = result.clickForwardConfig;
            } else {
              let isMiniApp = isMiniApplets();
              result.clickForwardConfig.diffPlatformClickForwardConfig.forEach(item => {
                if (isMiniApp === 'wechat' && item.platform == 1) {
                  this.clickForwardConfig = item;
                } else if (isMiniApp === 'alipay' && item.platform == 0) {
                  this.clickForwardConfig = item;
                } else if (isMiniApp === 'eleme' && item.platform == 2) {
                  this.clickForwardConfig = item;
                }
              })
            }
          }
        } else {
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff"
            },
            content: res.errorMessage,
            duration: 2000
          }).then(() => {
            console.log("finish");
          });
        }
      });
    },
    // 填写收货地址信息
    addLotteryAddress() {
      // if (this.userInfo.name.length > 15) {
      //   this.$alert.message("姓名不能超过15字", "提示");
      //   return;
      // }
      // if (!/1\d{10}/.test(this.userInfo.phone)) {
      //   this.$alert.message("手机号不符合规则", "提示");
      //   return;
      // }
      for (let i = 0; i < this.prizeFormItems.length; i++) {
        let item = this.prizeFormItems[i];
        switch (item.paramName) {
          case "name":
            if (!this.trim(this.userInfo.name)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【姓名】不能为空。",
                duration: 3000
              });
              return;
            }
            break;
          case "phone":
            if (!this.trim(this.userInfo.phone)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【手机号】不能为空。",
                duration: 3000
              });
              return;
            } else if (!/1\d{10}/.test(this.userInfo.phone)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【手机号】格式错误。",
                duration: 3000
              });
              return;
            }
            break;
          case "address":
            if (!this.trim(this.userInfo.address)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【收货地址】不能为空。",
                duration: 3000
              });
              return;
            }
            break;
          case "remark":
            if (!this.trim(this.userInfo.remark)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【备注】不能为空。",
                duration: 3000
              });
              return;
            }
            break;
          case "other":
            if (!this.trim(this.userInfo.other)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【其他】不能为空。",
                duration: 3000
              });
              return;
            }
            break;
        }
      }

      let params = {
        activityId: this.activityId,
        openId: this.openId,
        recordId: this.prize.recordId,
        ...this.userInfo
      };
      this.$fetch(
        { url: "/ehs/activity/user/address/add", method: "post" },
        params
      ).then(res => {
        if (res.success) {
          console.log({ grid: res.model });
          this.showMask = false;
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff"
            },
            content: "提交成功",
            duration: 2000
          }).then(() => {
            console.log("finish");
          });
        } else {
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff"
            },
            content: res.errorMessage,
            duration: 2000
          }).then(() => {
            console.log("finish");
          });
        }
      });
    },
    // 查询中奖用户列表
    getLotteryUserList() {
      let params = {
        activityId: this.activityId,
        openId: this.openId
      };
      this.$fetch(
        { url: "/ehs/activity/user/hit/list", method: "post" },
        params
      ).then(res => {
        if (res.success) {
          this.prizeInfoList = res.model || [];
        } else {
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff"
            },
            content: res.errorMessage,
            duration: 2000
          }).then(() => {
            console.log("finish");
          });
        }
      });
    },
    close(val) {
      this.showMask = val;
    },
    closeDialog() {
      this.prizeFontStyle = {};
      this.prizeBorderStyle = {};
      this.showMask = false;
    },
    // 查看我的奖品
    checkPrize(item) {
      console.log(item);
      //Integer	奖品类型	1怪兽充点券 2外部兑换码 3实物奖品 4 无兑换码礼包
      this.prize = item;
      this.getLotteryAddress();
      // this.showMask = true;
      this.modalType = "prize";
    },
    // 规则区域尾图点击跳转
    handleClick(str) {
      if (str == "rule") {
        this.$log.senLog({
          pointID: '12010014',
          eventType: 2,
          businessData: {
            activityType: this.activityType !== undefined ? this.activityType : '',
            activityId: this.activityId || '',
            appSource: isMiniApplets() ? isMiniApplets() : '',
            enterSource: this.enterSource || '',
          }
        })
        this.$emit("handleGridClick", this.ruleOption);
      } else if (str == "prize") {
        if (this.clickForwardConfig.jumpType == 6) {
          this.copyMsg(
            this.clickForwardConfig.urlPath
          )
        } else {
          this.$emit("handleGridClick", this.clickForwardConfig);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.guide-wrap {
  position: absolute;
  transform: translate3d(-50%, -40%, 0);
  width: 100vw;

  // height: 100vh;
  img {
    width: 100%;
    // height: 100%;
  }
}

.countError-wrap {
  width: 618px;
  height: 780px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prize-wrap {
  width: 618px;
  height: 780px;
  background-size: 100% 100% !important;
  position: relative;

  .ticket-code {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 200px;
  }

  .form {
    padding: 0 40px;
    position: absolute;
    bottom: 140px;
    box-sizing: border-box;
    // display: flex;
    // flex-direction: column;
    // justify-content: flex-end;
    width: 100%;
    box-sizing: border-box;

    .form-row {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .form-label {
      font-size: 28px;
      color: #fff;
      width: 30%;
    }

    .form-textarea,
    .form-input {
      flex: 1;
      width: 70%;
      // font-size: 28px;
      box-sizing: border-box;
      padding: 8px 15px;
      border-radius: 0;
      background: none;
      color: #fff;
      border-width: 1px;
      /* no */
      border-style: solid;
    }

    .form-input {
      // height: 48px;
      // line-height: 28px;
    }

    .form-textarea {
      height: auto;
    }
  }

  .btn {
    width: 350px;
    display: inline-block;
    /*no*/
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
  }

  .prize-area {
    width: 100%;
    height: 100%;
  }

  .prize-close {
    position: absolute;
    width: 100%;
    height: 30%;
    left: 0;
    bottom: 0;
  }
}

.energy-wrap,
.swiper-wrap {
  background-size: 100% 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.energy-wrap {
  height: 88px;
  letter-spacing: 2px;
}

.swiper-wrap {
  height: 78px;
  padding: 8px 0;
  overflow: hidden;

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      width: 100%;
      text-align: center;
      padding: 0 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.grid-wrap {
  // height: 590px;
  box-sizing: border-box;
  font-size: 0;
  // padding: 0 80px;
  display: flex;
  align-items: center;
  background-size: 100% 100% !important;
  background-repeat: no-repeat;
  position: relative;

  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;

    li {
      width: 178px;
      margin-bottom: 14px;
      height: 178px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        // width: 178px;
        // height: 178px;
      }

      &.current {
        // box-shadow: 0px 0px 6px #29c1c2;
      }

      &:nth-of-type(7),
      &:nth-of-type(8),
      &:nth-of-type(9) {
        margin-bottom: 0;
      }
    }
  }
}

.grid-btn-wrap {
  height: 200px;
  font-size: 0;
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100% !important;

  .btn {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
  }
}

.rule-wrap {

  .header,
  .footer {
    width: 100%;

    // height: 80px;
    img {
      width: 100%;
    }
  }

  .content {
    height: 480px;
    position: relative;

    .hot-area {
      width: 660px;
      height: 220px;
      position: absolute;
      left: 50%;
      display: flex;
      transform: translateX(-50%);

      div {
        flex: 1;
      }
    }
  }

  img {
    height: 100%;
  }
}

.reward-wrap {
  box-sizing: border-box;

  .header {
    width: 100%;

    img {
      width: 100%;
    }

    // height: 80px;
  }

  .active {
    max-height: 3.5 * 154px;
    overflow-y: auto;
  }

  .content {
    img {
      width: 100%;
      // height: 154px;
      display: block;
    }
  }

  .footer {
    width: 100%;

    img {
      width: 100%;
    }

    // height: 80px;
  }

  // img {
  //   height: 100%;
  // }
}

.content-wrap {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate3d(-50%, -50%, 0);

  .line {
    position: absolute;
    bottom: -90px;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 90px;
    display: flex;
    flex-direction: column;

    span {
      width: 4px;
      height: 10px;
      margin-top: 7px;
      background: #fff;
    }
  }

  .guanbi {
    position: absolute;
    width: 80px;
    height: 80px;
    bottom: -84px;
    left: 50%;
    color: #fff;
    transform: translateX(-50%);
  }

  .guanbi2 {
    position: absolute;
    width: 618px;
    height: 260px;
    bottom: 90px;
    left: -309px;
  }
}

.eleLoadingContent {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .eleLoading {
    width: 132px;
    height: 132px;
  }
}
</style>
